import { useEffect, useMemo, useState } from 'react';

import { PreviewList } from '@playbooks/molecules/lists';
import { SectionPanel, SectionPanelBody, SectionPanelFooter } from '@playbooks/molecules/panels/section-panel';
import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';

import { searchParams } from 'api';
import { SearchPreviewCard } from 'components/search/search-card';
import { useStore } from 'contexts';
import { useQuery } from 'hooks';

const SearchResultsTrending = ({ query, api, tableName, tableNames, onClick, className = '' }) => {
	const [trending, setTrending] = useState([]);
	const [params, setParams] = useState<any>({ ...searchParams, ...api });
	const [meta, setMeta] = useState({ page: 0, pageSize: 0, totalRecords: 0 });
	const store = useStore();

	// Computed
	const computedFilters = useMemo(() => {
		return tableName ? { modelName: tableName } : { modelName: tableNames.join(',') };
	}, [tableName, tableNames]);
	const computedHits = useMemo(() => {
		return trending.map(v => v.result);
	}, [JSON.stringify(trending)]);

	// Hooks
	useEffect(() => {
		fetchData();
	}, [tableName]);

	// Actions
	const [fetchData, loading] = useQuery(async () => {
		const response = await store.query({
			url: `/search-trending`,
			params: { ...params, ...computedFilters },
		});
		setTrending(response.data);
		setMeta(response.meta);
	});

	// Render
	return (
		<SectionPanel>
			<SectionPanelBody className='py-3'>
				<PreviewList
					data={computedHits}
					loading={loading}
					icon='magnifying-glass'
					title='Search Results'
					className={className}>
					{computedHits.map((hit, index) => (
						<div key={index}>
							<SearchPreviewCard hit={hit} onClick={onClick} className='p-4' />
						</div>
					))}
				</PreviewList>
			</SectionPanelBody>
			<SectionPanelFooter>
				<Link variant='outline' size='sm' aria-label='clear' href={`/search?query=${query}`} className='w-full'>
					View All
					<Icon data-icon='inline-end' type='far' icon='chevron-right' aria-hidden />
				</Link>
			</SectionPanelFooter>
		</SectionPanel>
	);
};
export { SearchResultsTrending };
